import {
  Box,
  Card,
  IconButton,
  LinearProgress,
  Typography,
} from '@material-ui/core'
import { Cancel } from '@material-ui/icons'

import { useStyles } from './styles'

interface LinearProgressWithLabelProps {
  title: string
  label?: string
  progressValue: number
  fileSize?: string
  isError?: boolean
  onClearFiles?: () => void
}

export const LinearProgressWithLabel = ({
  title,
  label,
  progressValue,
  fileSize,
  isError,
  onClearFiles,
}: LinearProgressWithLabelProps) => {
  const classes = useStyles()

  return (
    <Box className={classes.container}>
      <Box
        display='flex'
        justifyContent='space-between'
        className={classes.title}
      >
        <Typography variant={'body1'}>{title}</Typography>
        <span>{fileSize}</span>
      </Box>
      <Card className={classes.card} elevation={2}>
        <div>
          <Typography variant={'body2'}>{label}</Typography>
          <IconButton
            size='small'
            onClick={onClearFiles}
            aria-label='Remover arquivos'
          >
            <Cancel />
          </IconButton>
        </div>

        <LinearProgress
          aria-label={`Progresso do ${label}`}
          variant={progressValue || isError ? 'determinate' : 'indeterminate'}
          value={progressValue}
        />
      </Card>
    </Box>
  )
}
